import { ReactNode } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import 'dayjs/locale/de';
import 'dayjs/locale/el';
import 'dayjs/locale/es';
import 'dayjs/locale/pt';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/ja';
import 'dayjs/locale/ko';
import 'dayjs/locale/zh-cn';

import { getDayjsLocaleForLanguage } from '../../i18n/dayjs';
import { useLanguageContext } from './LanguageProvider';

export const AppLocalizationProvider = ({ children }: { children: ReactNode }) => {
  const { language } = useLanguageContext();
  const adapterLocale = getDayjsLocaleForLanguage(language);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={adapterLocale}>
      {children}
    </LocalizationProvider>
  );
};
